import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'; // Utilisation de useNavigate
import { setCurrentNavPage, setCurrentDndTheme } from "actions";
import _ from 'i18n';
import EditorSelectorTab from './EditorSelectorTab';
import ThemePreview from 'editor/ThemePreview';
import { STEPS } from 'Common';
import PageHeader from 'common/PageHeader';

const TypeSelector = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const step = useSelector((state) => state.params.step);
  const content = useSelector((state) => state.themes.content);

  useEffect(() => {
    // Set the current navigation page
    dispatch(setCurrentNavPage("CREATE_CAMPAIGN"));
  }, [dispatch]);

  const onTypeSelect = (type) => {
    if (type === "/drag-drop") {
      dispatch(setCurrentDndTheme(null));
    }
    navigate(type); // Utilisation de navigate pour changer de route
  };

  const showPreview = step === STEPS["THEME_PREVIEW"];

  return (
    <div>
      {showPreview && (
        <ThemePreview
          dispatch={dispatch}
          content={content}
          previous={{ step: STEPS["CREATE_CAMPAIGN"], url: "/campaign/selector" }}
        />
      )}
      <div id="home-page" className={`campaign-type__selector ${showPreview ? "hide" : ""}`}>
        <PageHeader
          header="Create email campaigns"
          subHeader="Create, manage and send your email campaigns."
          icon="EDIT_EMAIL"
        />
        <EditorSelectorTab onTypeSelect={onTypeSelect} />
      </div>
    </div>
  );
};

export default TypeSelector;
